import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {Brand} from "./Brand";
import {EsercizioData} from "./Esercizio";
import {IndirizzoData} from "./Indirizzo";

@Injectable({
   providedIn: 'root'
})
export class ClienteFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getClienti():Promise<Cliente[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Cliente, `/api/clienti`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getVendorClienti():Promise<Cliente[]>{
      return new Promise((resolve, reject) => {

      })
      }

   async getCliente(clienteId, vendorSlug=null):Promise<Cliente> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/clienti/${clienteId}` : `/api/clienti/${clienteId}`
      return new Promise((resolve, reject) => {
         ServerService.instance.get(Cliente, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getVendorCliente(vendorSlug, clienteId):Promise<Cliente> {
      return new Promise((resolve, reject) => {
         ServerService.instance.get(Cliente, `/api/esercizi/${vendorSlug}/vendorclienti/${clienteId}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postCliente(data, vendorSlug=null):Promise<Cliente[]> {
      console.log(vendorSlug)
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorclienti` : `/api/clienti`
      return new Promise((resolve, reject) => {
         ServerService.instance.post( url, data, Cliente).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postVendorCliente(vendorSlug, data) {
      return new Promise((resolve, reject) => {
         ServerService.instance.post( `/api/esercizi/${vendorSlug}/vendorclienti`, data, Cliente).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putCliente(clienteId, data, vendorSlug=null):Promise<Cliente[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorclienti/${clienteId}` : `/api/clienti/${clienteId}`
      return new Promise((resolve, reject) => {
         ServerService.instance.put( url, data, Cliente).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteCliente(clienteId, vendorSlug=null):Promise<Cliente[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorclienti/${clienteId}` : `/api/clienti/${clienteId}`
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( url, {}, Cliente).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async approvaCliente(clienteId) {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/clienti/${clienteId}/approva`, {}, Cliente).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getClienteEmail(vendorSlug, email):Promise<Cliente> {
      return new Promise((resolve, reject) => {
         ServerService.instance.get(Cliente, `/api/esercizi/${vendorSlug}/clienti?email=${email}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class ClienteData {
   id?: number | null;
   nome?: string;
   cognome?: string;
   data_nascita?: string;
   sesso?: string;
   tipo?: string;
   email?: string;
   ragione_sociale?: string;
   // cod_id?: string;
   pivacf?: string;
   telefono?: string;
   note?: string;
   note_vendor?: string;
   esercizio?:EsercizioData
   indirizzo?: IndirizzoData;

}

export class Cliente {

   data:ClienteData = {}

   constructor(data:ClienteData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/clienti`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   public static Sesso = [
      {value:'M', display:"Maschio"},
      {value:'F', display:"Femmina"},
      {value:'ND', display:"Altro"}
   ]

   public static Tipo = [
      {value:'PF', display:"Privato"},
      {value:'AZ', display:"Azienda"},
   ]

   public static TipoChoices = {
      'Privato': 'PF',
      'Azienda': 'AZ'
   }

}
